import { useValidationsField } from '@insurance/hooks'
import { Col, Form, Row, Select } from 'antd'

type Props = {
  periodProps: { name: string[]; label: string }
  installmentsProps: { name: string[]; label: string }
  periodOptions: { label: string; value: number }[]
  installmentsOptions: { label: string; value: number }[]
  periodDisabled?: boolean
  installmentsDisabled?: boolean
}

export const Period = ({
  periodProps,
  installmentsProps,
  periodOptions,
  installmentsOptions,
  periodDisabled,
  installmentsDisabled
}: Props) => {
  const { required } = useValidationsField()

  return (
    <Row gutter={[12, 12]}>
      <Col xs={24} lg={12}>
        <Form.Item {...periodProps} rules={[required]}>
          <Select
            disabled={periodDisabled}
            placeholder={periodProps.label}
            options={periodOptions}
          />
        </Form.Item>
      </Col>

      <Col xs={24} lg={12}>
        <Form.Item {...installmentsProps} rules={[required]}>
          <Select
            disabled={installmentsDisabled}
            placeholder={installmentsProps.label}
            options={installmentsOptions}
          />
        </Form.Item>
      </Col>
    </Row>
  )
}
